declare global {
  interface Window {
    omniscriptLoaded: boolean;
    s: any;
    omnidata: any;
    omniInteractionQueue?: any[];
  }
}

export type PageName =
  | "LANDING"
  | "LANDING_RETAIL"
  | "LANDING_MYPARTNER"
  | "LISTING"
  | "REVIEW"
  | "PAYMENT"
  | "THANK_YOU_POLICY"
  | "THANK_YOU_PASSPORT"
  | "ADD_PASSPORT"
  | "ORDER_SUMMARY"
  | "ORDER_DETAILS"
  | "COMMON_LANDING"
  | "COMMON_LANDING_RETAIL";

let landingPageAnalytics: any;
export const setLandingPageAnalytics = (analytics?: any) => {
  landingPageAnalytics = analytics;
};

export const getLandingPageAnalytics = () => landingPageAnalytics;

export type PageLoadEvent = {
  pageName: PageName;
  bookingId?: string;
  experiment?: string;
  bookingStatus?: "success" | "failure";
  country?: string;
  startDate?: string;
  endDate?: string;
  travellers?: string;
  purpose?: string;
  segment?: string;
};

export type PageLoadErrorEvent = {
  pageName: PageName;
  actionType: "page_load_error";
  error: string;
};

export type IOmniData = {
  m_ch?: string;
  m_v15?: string;
  m_v24?: string;
  m_v16?: string;
  pageName?: string;
  purchaseID?: string;
};

export type FunnelVars = {
  pageName: string;
  lob: string;
  siteSection: string;
};
type CommonLandingEventsWithoutPayload =
  | "page_load"
  | "travel_insurance_card_clicked"
  | "my_orders_clicked"
  | `protection_plan_${string}_clicked`
  | `educationModal_${string}`
  | "explore_clicked"
  | "productOfferBanner_shown"
  | "persuasion_shown"
  | "persuasion_clicked"
  | "productInfo_card_clicked"
  | "productInfo_knowMore_clicked"
  | "segments_shown";

type CommonLandingEventsWithPayload =
  | "error_shown"
  | "date_selected"
  | "country_selected"
  | "segment_clicked"
  | "travelPlans_shown"
  | "offeredBy_shown"
  | "traveller_count_selected"
  | "age_ranges_selected";

export type CommonLandingEvents =
  | { actionType: CommonLandingEventsWithoutPayload }
  | { actionType: CommonLandingEventsWithPayload; payload: string };

type LandingEventsWithoutPayload =
  | "page_load"
  | "lobStrip_tripmoney_insurance_clicked"
  | "explore_plan_click"
  | "upcoming_trips_shown"
  | "upcoming_trips_clicked"
  | "why_buy_makemytrip_insurance_seen"
  | "benefits_seen"
  | "claims_seen"
  | "footer_seen"
  | "my_orders_clicked"
  | "upcoming_domestic_trips_clicked"
  | "upcoming_domestic_trips_shown"
  | `offer_banner${number}_clicked`
  | `offer_banner${number}_shown`
  | "student_segment_clicked"
  | "regular_segment_clciked"
  | "special_segments_shown"
  | `faq_section${number}_seen`
  | `faq_section${number}_clicked`
  | `Ins_CountrySelected:${string}`
  | "Ins_Country_popuploaded"
  | "Ins_Country_popup_searchclicked"
  | `Ins_Country_popup_checkbox:${string}`
  | "Ins_Country_popup_AddDestinationClicked"
  | "Ins_TravellerAndAgeDropDownClicked"
  | "Ins_TravellerAndAgeModified"
  | "Ins_TravelDateDropDownClicked"
  | "Ins_ViewAllOrdersClicked"
  | "Ins_DisclaimerPopUpShown"
  | "Ins_DisclaimerClicked"
  | "Ins_DisclaimerClosed"
  | "Ins_DisclaimerBackClicked"
  | "Ins_DisclaimerCheckBoxChecked"
  | "Ins_DisclaimerCheckBoxUnchecked"
  | "Ins_DisclaimerAccepted"
  | "chatbot_shown"
  | "chatbot_clicked"
  | `educationModal_${string}`
  | "productInfo_knowMore_clicked"
  | "productInfo_card_clicked";

type LandingEventsWithPayload =
  | "error_shown"
  | "popular_country_selected"
  | "other_countries_clicked"
  | "searched_countries"
  | "selected_countries";

export type LandingEvents =
  | { actionType: LandingEventsWithoutPayload }
  | { actionType: LandingEventsWithPayload; payload: string }
  | {
      actionType: "travel_date_selected";
      payload: { departure: string; arrival: string };
    };

type ListingEventsWithoutPayload =
  | "buy_now_clicked_outside_insurance"
  | "buy_now_clicked_outside_assistance"
  | "buy_now_clicked_outside_combo"
  | "buy_now_clicked_outside_student_insurance"
  | "buy_now_clicked_details_student_insurance"
  | "buy_now_clicked_details_insurance"
  | "buy_now_clicked_details_assistance"
  | "buy_now_clicked_details_combo"
  | "edit_clicked"
  | "View_details_insurance"
  | "View_details_assistance"
  | "View_details_combo"
  | "View_details_student_insurance"
  | "details_pop_shown_insurance"
  | "details_pop_shown_assistance"
  | "details_pop_shown_combo"
  | "TnC_clicked_insurance"
  | "TnC_clicked_assistance"
  | "TnC_clicked_combo"
  | "TnC_clicked_student_insurance"
  | "compare_selected"
  | "comparenow_opened"
  | "buy_from_compare"
  | `${string}_seen`
  | `chatbot_shown`
  | `chatbot_clicked`
  | `educationModal_${string}`
  | "productInfo_knowMore_clicked"
  | "productInfo_card_clicked";

type ListingEventsWithPayload =
  | "page_load"
  | "error_shown"
  | "sum_insured_selected";

export type ListingEvents =
  | { actionType: ListingEventsWithoutPayload }
  | { actionType: ListingEventsWithPayload; payload: string };

type TravDetailsEventsWithoutPayload =
  | "page_load"
  | "edit_details_clicked"
  | "edit_product_clicked"
  | "price_breakup_clicked"
  | "price_breakup_popup"
  | "TnC_clicked"
  | "health_disclaimer_clicked"
  | "age_disclaimer_clicked"
  | "buy_clicked"
  | "buy_clicked_outside_domestic"
  | "buy_clicked_details_domestic"
  | "contact_details_filled"
  | "traveller_name_filled"
  | "dob_selected"
  | "gender_selected"
  | "saved_traveller_clicked"
  | "saved_traveller_edit_clicked"
  | "Add_button_clicked"
  | "Remove_clicked"
  | "Filter_selected"
  | "View_detail_clicked"
  | "Adventure_added"
  | "Electronics_added"
  | "Added_in_bs"
  | "Buy_in_bs"
  | `chatbot_shown`
  | `chatbot_clicked`
  | `viewAllButton_clicked`
  | `viewLessButton_clicked`
  | `viewAll_shown`;

type TravDetailsEventsWithPayload = "error_shown";

export type TravDetailsEvents =
  | { actionType: TravDetailsEventsWithoutPayload }
  | { actionType: TravDetailsEventsWithPayload; payload: string };

type ThankYouEventsWithoutPayload =
  | "download_policy_clicked"
  | "my_orders_clicked"
  | "add_passport_clicked"
  | "nps_form_closed"
  | "nps_submitted"
  | `nps_rating_${number}`;

type ThankYouEventsWithPayload = "page_load";

export type ThankYouEvents =
  | {
      pageName: PageName;
      actionType: ThankYouEventsWithoutPayload;
    }
  | {
      pageName: PageName;
      actionType: ThankYouEventsWithPayload;
      payload: string;
    };

type AddPassportEventsWithoutPayload = "details_filled" | "submit_clicked";

type AddPassportEventsWithPayload = "page_load";

export type AddPassportEvents =
  | { actionType: AddPassportEventsWithoutPayload }
  | { actionType: AddPassportEventsWithPayload; payload: string };

type OrderSummaryEventsWithoutPayload = "page_load" | "order_clicked";

type OrderSummaryEventsWithPayload = "page_load_error";

export type OrderSummaryEvents =
  | { actionType: OrderSummaryEventsWithoutPayload }
  | { actionType: OrderSummaryEventsWithPayload; payload: string };

type OrderDetailsEventsWithoutPayload =
  | "page_load"
  | "download_policy_clicked"
  | "edit_details_clicked"
  | "claim_insurance_clicked"
  | "email_policy_clicked"
  | "raise_issue_clicked"
  | "view_benefits_clicked"
  | "price_breakup_clicked"
  | "download_invoice_clicked"
  | "edit_traveller_clicked"
  | "alternate_contact_clicked"
  | "write_clicked"
  | "call_clicked"
  | "help_clicked"
  | "add_passport_clicked";

type OrderDetailsEventsWithPayload = "page_load_error";

export type OrderDetailsEvents =
  | { actionType: OrderDetailsEventsWithoutPayload }
  | { actionType: OrderDetailsEventsWithPayload; payload: string };

export interface IAnalytics {
  trackPageLoadEvent(event: PageLoadEvent, type?: string): void;
  trackRawPageLoadEvent(event: any, type?: string): void;
  trackPageLoadErrorEvent(event: PageLoadErrorEvent, type?: string): void;
  trackCommonLandingEvents(
    event: CommonLandingEvents,
    eventType?: string
  ): void;
  trackLandingEvents(
    event: LandingEvents,
    eventType?: string,
    type?: string
  ): void;
  trackListingEvents(
    event: ListingEvents,
    eventType?: string,
    type?: string
  ): void;
  trackTravDetailsEvents(
    event: TravDetailsEvents,
    eventType?: string,
    type?: string
  ): void;
  trackAddPassportEvents(event: AddPassportEvents, eventType?: string): void;
  trackThankYouEvents(
    event: ThankYouEvents,
    eventType?: string,
    type?: string
  ): void;
  trackOrderSummaryEvents(event: OrderSummaryEvents, eventType?: string): void;
  trackOrderDetailsEvents(event: OrderDetailsEvents, eventType?: string): void;
}
